import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }

import SfxInput from "src/components/input/SfxInput.vue"
import SfxIssueBase from "src/components/issue/SfxIssueBase.vue"
import { computed, ref, watch } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits

// expected value examples: "4 13:34:36", "00:08:05", null
const seconds = "00"

export default /*#__PURE__*/_defineComponent({
  __name: 'SfxIssueTimeRequirements',
  props: {
  timeEstimate: {
    type: String,
    default: null,
  },

  required: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:timeEstimate", "hide"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

__expose({ forceHide, forceShow })

//endregion

//region Variables

const { t } = useI18n()
const issueBase = ref<typeof SfxIssueBase | undefined>()
const title = t("sfxIssues.title_time_requirements")

const days = ref(0)
const hoursModel = ref(0)
const minutesModel = ref(0)
const promptDiscard = computed(() => Boolean(hoursModel.value !== 0 || minutesModel.value !== 0))

//endregion

//region Functions

function getTime(time: string) {
  if (time) {
    let data = time.trim()
    let initialDays = 0

    // verify the estimated time has any days data
    if (data.includes(" ")) {
      const split = data.split(" ")
      initialDays = Number(split[0])
      data = split[1]
    }

    // ignoring the seconds as those values doesn't make a significant difference
    const hoursAndMinutes = data.split(":")
    hoursModel.value = Number(hoursAndMinutes[0]) + initialDays * 24
    minutesModel.value = Number(hoursAndMinutes[1])
  }
}

function setTime() {
  days.value = 0

  // validate the minutes input
  if (minutesModel.value > 59) {
    minutesModel.value = 59
  } else if (minutesModel.value < 0) {
    minutesModel.value = 0
  }

  // validate the hours input
  if (hoursModel.value < 0) {
    hoursModel.value = 0
  }

  if (hoursModel.value > 24) {
    days.value = Math.floor(hoursModel.value / 24)
  }

  const dayCount = String(days.value)
  const hour = String(hoursModel.value % 24).padStart(2, "0")
  const minutes = String(minutesModel.value).padStart(2, "0")

  // adding seconds as 00 to match with the initial date format
  let formattedString = hour.concat(":", minutes).concat(":", seconds)

  if (days.value) formattedString = dayCount.concat(" ", formattedString)

  return formattedString
}

function hideMenu() {
  days.value = 0
  hoursModel.value = 0
  minutesModel.value = 0
  emit("hide")
}

function forceHide() {
  hideMenu()
  issueBase.value?.forceHide()
}

function forceShow() {
  issueBase.value?.forceShow()
}

//endregion

//region Setup Code

watch(
  () => props.timeEstimate,
  () => {
    getTime(props.timeEstimate)
  },
  { immediate: true }
)

watch(
  () => [hoursModel.value, minutesModel.value],
  () => {
    emit("update:timeEstimate", setTime())
  }
)

//endregion

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SfxIssueBase, {
    ref_key: "issueBase",
    ref: issueBase,
    title: _unref(title),
    required: __props.required,
    "prompt-discard": promptDiscard.value,
    "info-notification": "",
    onHide: hideMenu
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(SfxInput, {
          modelValue: hoursModel.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((hoursModel).value = $event)),
          class: "col-6 q-pr-sm",
          label: _ctx.$t('sfxIssues.label_hours'),
          type: "number",
          min: "0"
        }, null, 8, ["modelValue", "label"]),
        _createVNode(SfxInput, {
          modelValue: minutesModel.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((minutesModel).value = $event)),
          class: "col-6 q-pl-sm",
          label: _ctx.$t('sfxIssues.label_minutes'),
          type: "number",
          min: "0",
          max: "59"
        }, null, 8, ["modelValue", "label"])
      ])
    ]),
    _: 1
  }, 8, ["title", "required", "prompt-discard"]))
}
}

})